<script setup lang="ts">
import type { VTextarea } from 'vuetify/components';
import AppTypography from './AppTypography.vue';

const attrs = useAttrs();

const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  hideDetails = 'auto',
  label = '',
  placeholder = '',
  rounded = 'lg',
  withCounter = false,
  maxLength = undefined,
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  hideDetails?: VTextarea['hideDetails'];
  label?: string;
  placeholder?: string;
  rounded?: string | number | boolean;
  withCounter?: boolean;
  maxLength?: VTextarea['maxLength'];
}>();

const text = defineModel<string | number>();
</script>
<template>
  <v-textarea
    v-model="text"
    v-bind="attrs"
    flat
    variant="solo-filled"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :rounded="rounded"
    data-testid="text-field"
  ></v-textarea>
  <AppTypography
    v-if="withCounter && errorMessages.length === 0"
    type="caption-2"
    class="pl-4"
    style="color: rgb(var(--v-theme--tertiary)) !important"
    >{{ `${(text as string)?.length}/${maxLength} characters` }}</AppTypography
  >
</template>

<style></style>
